/* eslint-disable max-len */

export default {
  "questions": [
    {
      "answer": [
        "Rocksbox is a subscription based try before you buy jewelry service. You'll receive three" +
        " pieces of jewelry that are yours to wear and try out for as long as you like.",
        "When you're ready to get more jewelry, go to the <a class='small' target='_blank' href='/account/feedback'>Buy From My Set</a> page to buy the pieces you want to keep." +
        " Put the pieces you don’t want to buy back in the reusable envelope using the prepaid shipping label. Drop" +
        " the package in the mail or at a <a class='small' target='_blank' href='https://tools.usps.com/go/POLocatorAction!input.action'>USPS drop-off location</a>.",
        "Your stylist will start working on your next set when your Rocksbox is returned. If you buy all three" +
        " pieces, your stylist will work on your next set right away (no need to send back your empty box).",
        "Don’t forget to check out the Shop where you get exclusive and immediate access to buy <a class='small' target='_blank' href='/shop'>New</a> and <a class='small' target='_blank' href='/shop/clearance'>Clearance</a>" +
        " Rocksbox jewelry."
      ],
      "expanded": false,
      "question": "How does Rocksbox work?"
    },
    {
      "answer": [
        "You can track the status of your Rocksbox shipment by clicking “Track Shipping Status” in the main" +
        " menu. Typically, your Rocksbox will take 3-5 business days to be delivered once it has been shipped."
      ],
      "expanded": false,
      "question": "Where is my shipment?"
    },
    {
      "answer": [
        "Every Rocksbox member gets a monthly credit to be used toward purchasing jewelry from your set." +
        " The monthly credit is available starting the first day of each month and must be used in that same" +
        " month. At this time your credit cannot be used to purchase jewelry from the New Jewelry or Clearance Shop."
      ],
      "expanded": false,
      "question": "What is the monthly credit?"
    },
    {
      "answer": [
        "Not to worry! To print out a replacement return label, go to the <a class='small' target='_blank' href='/account'>My Account</a> page then click Reprint" +
        " Return Label.",
        "If you have lost or misplaced the reusable envelope, you can use any envelope or box that your Rocksbox" +
        " will fit in. Please package the items carefully for safe shipping, apply the return shipping label, and" +
        " drop it in the mail or at a <a class='small' target='_blank' href='https://tools.usps.com/go/POLocatorAction!input.action'>USPS drop-off location</a>."
      ],
      "expanded": false,
      "question": "What if I misplace my return label?"
    },
    {
      "answer": [
        "Enter your new shipping address on the <a class='small' target='_blank' href='/account/shipping'>Shipping</a> page. Please change your address before" +
        " returning or purchasing your set so we can send your next Rocksbox to the correct address. If your" +
        " set has already been shipped we're unable to reroute the package."
      ],
      "expanded": false,
      "question": "How do I change my shipping address?"
    }
  ]
};
